import React, { forwardRef } from 'react';

import { Dialog } from 'primereact/dialog';

import { generateGUID } from '../../utils';

import TaskCodeChoiseCard from './TaskCodeChoiseCard'; // Adjust path as necessary

interface TaskCodeDialogProps {
  closeCodeDialogVisible: boolean;
  selectedAction: any;
  closingCodes: any[];
  onHidetaskCodeCard: () => void;
  handleCodeDialogSave: (data: any) => void;
  closeDialog: () => void;
  saveDialog: () => void;
}

const TaskCodeDialog = forwardRef<any, TaskCodeDialogProps>(
  (
    {
      closeCodeDialogVisible,
      selectedAction,
      closingCodes,
      onHidetaskCodeCard,
      handleCodeDialogSave,
      closeDialog,
      saveDialog
    },
    ref
  ) => {
    return (
      <Dialog
        header="Выбор шифра закрытия наряда"
        visible={closeCodeDialogVisible && selectedAction?.id !== undefined}
        style={{ minWidth: '343px', width: '743px', minHeight: '274px' }}
        breakpoints={{ '960px': '75vw', '641px': '90vw' }}
        maximizable
        modal
        onHide={() => onHidetaskCodeCard()}
      >
        {selectedAction?.id && (
          <TaskCodeChoiseCard
            key={generateGUID()}
            closingCodes={closingCodes}
            onAdd={handleCodeDialogSave}
            closeDialog={closeDialog}
            saveDialog={saveDialog}
            ref={ref}
          />
        )}
      </Dialog>
    );
  }
);

TaskCodeDialog.displayName = 'TaskCodeDialog';

export default TaskCodeDialog;
